/** The «…NotUsed» variant of a text where the organisation has no safety representatives, if the text has one */
export const safetyRepText = (usesSafetyReps: boolean) => (key: string) =>
  usesSafetyReps ? key : [`${key}NotUsed`, key];
